import React from "react";
import {Form, Icon, Switch} from "antd";
import User from "../../../services/User";

import "./TasksTableHeader.css"

import SAInputSearch from "../../common/input/SAInputSearch";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";
import {getFilters, getFiltersCounters, getInitFilters,} from "../../../selectors/fetchInterventions";
import {connect} from "react-redux";
import * as types from "../../../constants/ActionTypes";

class TasksTableHeader extends React.Component {
  interventionStatus = 'interventionStatus';

  constructor(props) {
    super(props);
    this.state = ({
      currentSearchValue: null,
      buttons: {
        interventionStatus: [
          Constants.STATUS_OPEN,
          Constants.STATUS_OPEN_48,
          Constants.STATUS_READY_FOR_APPOINTMENT,
          Constants.STATUS_ONGOING,
        ],
        type: [Constants.TYPE_PITSTOP],
      },
    })
  }

  onSearch(value, apiKey, contentUpdater) {
    const map = {};
    map[apiKey] = value;
    contentUpdater(map);
  }

  onChange(event) {
    if (this.state.currentSearchValue !== event.target.value) {
      this.setState({
        currentSearchValue: event.target.value
      });
    }
  }

  toggleFilter = (filter, buttonGroup) => {
    const {contentUpdater, filters, dispatchSetFilters} = this.props;
    const map = {...filters};
    const filterIndex = map[buttonGroup].findIndex(i => i === filter);
    if (filterIndex === -1) {
      map[buttonGroup].push(filter);
    } else {
      map[buttonGroup].splice(filterIndex, 1);
    }
    dispatchSetFilters(map);
    contentUpdater({ [buttonGroup]: map[buttonGroup] });
  }

  render() {
    const {buttons} = this.state;
    const {
      intl: {formatMessage},
      contentUpdater,
      showArchived,
      showOnlyMine,
      onShowArchived,
      onShowOnlyMine,
      filters,
      counters,
      initListLoad
    } = this.props;

    return (
      <header className="table-wrapper__header">
        <Form className="table-search">
          <div className="table-search__field">
            <label htmlFor="table-search" className="sr-only">Search in overview table</label>
            <SAInputSearch
              type="text" id="table-search"
              placeholder={formatMessage({id: 'placeholder.search'})}
              enterButton={true} value={this.state.currentSearchValue}
              onSearch={(value) => this.onSearch(value, "search", contentUpdater)}
              onChange={(event) => this.onChange(event)}
            />
          </div>
        </Form>
        <div className="table-buttons">
          {Object.keys(buttons).map(buttonGroup => buttons[buttonGroup].map((b, i) =>
            <div key={i} className="table-buttons__button">
              <button
                key={b.value}
                type="primary"
                className={`btn ${filters[buttonGroup] && filters[buttonGroup].includes(b.value) ? 'btn-outline-active' : 'btn-outline'} `}
                onClick={() => this.toggleFilter(b.value, buttonGroup)}
              >
                {formatMessage(b.label)}
                &nbsp;({counters[buttonGroup] && counters[buttonGroup][b.value] ? counters[buttonGroup][b.value] : 0})
              </button>
            </div>)
          )}
        </div>
        <div className="ant-row-flex-middle">
          <Icon type="delete" style={{fontSize: '16px', paddingRight: '10px'}} onClick={() => initListLoad()}/>
          <Icon type="sync" style={{fontSize: '16px', paddingRight: '10px'}} onClick={this.props.onListRefresh}/>
          <Switch checked={showArchived} defaultChecked={false} onChange={onShowArchived}/>
          &nbsp;{formatMessage({id: 'tasksTable.showArchived'})}&nbsp;&nbsp;
          {User.isCallCenterAgent() &&
            <React.Fragment>
              <Switch checked={showOnlyMine} defaultChecked={false} onChange={onShowOnlyMine}/>
              &nbsp;{formatMessage({id: 'tasksTable.showOnlyMine'})}
            </React.Fragment>
          }
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  filters: getFilters(state),
  initFilters: getInitFilters(state),
  counters: getFiltersCounters(state),
});

const mapDispatchToProps = dispatch => ({
  dispatchSetFilters: (filters) => dispatch({type: types.SET_FILTERS, filters}),
  dispatchResetFilters: () => dispatch({type: types.RESET_FILTERS}),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TasksTableHeader));



// WEBPACK FOOTER //
// ./src/components/overview/table/TasksTableHeader.js